module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePageNew', {
    ref: "unUsedTable",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "零用水设备查询",
      "label": "",
      "labelName": "",
      "operation": _vm.operation,
      "operationWidth": 100,
      "resource": _vm.resource,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-161147c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/WaterUnused.vue
// module id = 1701
// module chunks = 1